'use strict'

import angular from 'angular'

import buySheetGeoLocationsFieldComponentHtmlUrl from './buySheetGeoLocationsField.component.html'

angular.module('buySheet.components').component('buySheetGeoLocationsField', {
    templateUrl: buySheetGeoLocationsFieldComponentHtmlUrl,
    bindings: {
        rawGeoLocations: '<',

    },
    controller() {
        this.geoLocations = typeof this.rawGeoLocations === 'string' ? JSON.parse(this.rawGeoLocations) : this.rawGeoLocations


        // this.geoLocations.Locations = [{style: {'break-after':'always'}, value: this.geoLocations.Locations[0]}]
        // console.log(this.geoLocations)
    },
    controllerAs: 'vm'
})